import { render, staticRenderFns } from "./pasargad.vue?vue&type=template&id=37ec0d2c&scoped=true"
import script from "./pasargad.vue?vue&type=script&lang=js"
export * from "./pasargad.vue?vue&type=script&lang=js"
import style0 from "./pasargad.vue?vue&type=style&index=0&id=37ec0d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ec0d2c",
  null
  
)

export default component.exports